import { useEffect, useState, useCallback } from "react";
import { log } from "../helpers";
import LocationModel from "../models/User/locationModel";

const useLocation = () => {
  const [country, setCountry] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const getLocation = useCallback(
    async (signal) => {
      setIsLoading(true);
      const locationModel = new LocationModel();
      const response = await locationModel.locationRequest({ signal });
      // Throw error if response is not OK (4xx/5xx status)
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      const data = await response.json();
      const countryCode = data?.countryCode;

      if (!countryCode) {
        throw new Error("No country code received");
      }
      return countryCode;
    },
    [setIsLoading]
  );

  useEffect(() => {
    // Create controller for aborting the request
    const abortController = new AbortController();

    getLocation(abortController.signal)
      .then((countryCode) => {
        setCountry(countryCode);
      })
      .catch((err) => {
        // Ignore abort errors, log others
        if (err.name !== "AbortError") {
          log(err, "LOCATION ERROR", true);
          setCountry("");
        }
      })
      .finally(() => {
        setIsLoading(false);
      });

    // Cleanup function to abort request on unmount
    return () => abortController.abort();
  }, [getLocation]);

  return {
    countryCode: country, // Current country code (or empty string if error/loading)
    isLoadingCountryCode: isLoading, // Loading status boolean
  };
};

export default useLocation;
